// extracted by mini-css-extract-plugin
module.exports = {"bio":"bio-module--bio--2UdAz","bio__contact":"bio-module--bio__contact--2eL2m","bio__iconWrapper":"bio-module--bio__icon-wrapper--1Dt-E","bio__icon":"bio-module--bio__icon--3btcx"};